export default "__VITE_ASSET__D5Z8KXei__"